export class ReferralFilter {
	userId: number;
	partnerId: number; // partnerId and userId is mutually exclusive, only one of them should be provided in filter params
	referToEmail: string;
	referByEmail: string;
	referralDate: string;
	paymentStatusId: number;
}